import './mt-subscriptions-grid.styles.scss';
import MtSubscriptionBox from '../mt-subscription-box/mt-subscription-box.component';
import AffinityLogo from '../../assets/logos/partners/affinity.svg';

const MtSubscriptionsGrid = () => {
    const subscriptions = [
        {
            id: 1,
            header: 'ANUAL MULTI-TRIP',
            title: 'AFFINITY 60 LATAM',
            price: 1850,
            installmentsNumber: 6,
            advantages: ['Assistência médica hospitalar de 60 mil dólares', '30 dias por viagem', 'Média de R$5,03 por dia'],
            logoUrl: AffinityLogo,
        },
        {
            id: 2,
            header: 'ANUAL MULTI-TRIP',
            title: 'AFFINITY 60 LATAM',
            price: 1850,
            installmentsNumber: 6,
            advantages: ['Assistência médica hospitalar de 60 mil dólares', '30 dias por viagem', 'Média de R$5,03 por dia'],
            logoUrl: AffinityLogo,
        },
        {
            id: 3,
            header: 'ANUAL MULTI-TRIP',
            title: 'AFFINITY 60 LATAM',
            price: 1850,
            installmentsNumber: 6,
            advantages: ['Assistência médica hospitalar de 60 mil dólares', '30 dias por viagem', 'Média de R$5,03 por dia'],
            logoUrl: AffinityLogo,
        },
    ]

    return (
        <div className='mt-subscriptions-grid-container'>
            {subscriptions.map(subscription => (
                <MtSubscriptionBox key={subscription.id} subscription={subscription}/>
            ))}
        </div>
    )
}

export default MtSubscriptionsGrid;